import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import resourcesToBackend from 'i18next-resources-to-backend';
import { getCurrentLanguage, initializeLanguage } from './utils/languageUtils';

// Инициализируем язык при загрузке
initializeLanguage();

i18next
  .use(initReactI18next)
  .use(LanguageDetector)
  .use(
    resourcesToBackend((language: string, namespace: string) => 
      import(`./Locales/${language}/${namespace}.json`)
    )
  )
  .init({
    fallbackLng: 'en',
    lng: getCurrentLanguage(),
    ns: ['common', 'forms', 'explore', 'service', 'trade_in', 'guarantee'],
    defaultNS: 'common',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false
    }
  });

export default i18next;
 